import { fb_remote_config } from '@/utils/firebase.js';

export default {
    state: {
        is_hide_prepay_topup: true,
        is_hide_prepay_balance_if_zero: true,
        is_afterpay_payment_module_allowed_fb: false,
        is_enable_promo_code_menu_item: false,
        is_klarna_payment_module_allowed: false,
        show_addon_images: true,
        show_carryover: false,
        is_module_ufb_enabled: false,
        show_dashboard_widget: "Hotspot,MMS,Data,Voice,SMS",
        show_hotspot: false,
    },

    getters: {
        is_hide_prepay_topup: (state) => state.is_hide_prepay_topup,
        is_hide_prepay_balance_if_zero: (state) => state.is_hide_prepay_balance_if_zero,
        is_afterpay_payment_module_allowed_fb: (state) => state.is_afterpay_payment_module_allowed_fb,
        is_enable_promo_code_menu_item: (state) => state.is_enable_promo_code_menu_item,
        is_klarna_payment_module_allowed: (state) => state.is_klarna_payment_module_allowed,
        show_addon_images: (state) => state.show_addon_images,
        show_carryover: (state) => state.show_carryover,
        is_module_ufb_enabled: (state) => state.is_module_ufb_enabled,
        show_dashboard_widget: (state) => state.show_dashboard_widget,
        show_hotspot: (state) => state.show_hotspot
    },

    actions: {
        get_is_hide_prepay_topup({commit}) {
            fb_remote_config.fetchAndActivate().then(() => {
                const is_hide_prepay_topup = fb_remote_config.getValue("hide_prepay_topup").asBoolean()

                commit('SET_IS_HIDE_PREPAY_TOPUP', is_hide_prepay_topup)

                return is_hide_prepay_topup
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.hide_prepay_topup

                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_IS_HIDE_PREPAY_TOPUP', defaultValue)
                
                return defaultValue
            })
        },

        get_is_hide_prepay_balance_if_zero({commit}) {
            fb_remote_config.fetchAndActivate().then(() => {
                const is_hide_prepay_balance_if_zero = fb_remote_config.getValue("hide_prepay_balance_if_zero").asBoolean()

                commit('SET_IS_HIDE_PREPAY_BALANCE_IF_ZERO', is_hide_prepay_balance_if_zero)
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.hide_prepay_balance_if_zero

                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_IS_HIDE_PREPAY_BALANCE_IF_ZERO', defaultValue)
                
                return defaultValue
            })
        },

        get_is_afterpay_payment_module_allowed({commit}) {
            fb_remote_config.fetchAndActivate().then(()=>{
                const is_afterpay_payment_module_allowed_fb = fb_remote_config.getValue("VUE_APP_IS_AFTERPAY_PAYMENT_MODULE_ALLOWED").asBoolean()
                commit('SET_IS_AFTERPAY_PAYMENT_MODULE_ALLOWED', is_afterpay_payment_module_allowed_fb)
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.VUE_APP_IS_AFTERPAY_PAYMENT_MODULE_ALLOWED

                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_IS_AFTERPAY_PAYMENT_MODULE_ALLOWED', defaultValue)
                
                return defaultValue
            })
        },
        
        get_is_enable_promo_code_menu_item({commit}) {
            fb_remote_config.fetchAndActivate().then(()=>{
                const is_enable_promo_code_menu_item = fb_remote_config.getValue("VUE_APP_ENABLE_PROMO_CODE_MENU_ITEM").asBoolean()
                commit('SET_IS_ENABLE_PROMO_CODE_MENU_ITEM', is_enable_promo_code_menu_item)
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.VUE_APP_ENABLE_PROMO_CODE_MENU_ITEM

                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_IS_ENABLE_PROMO_CODE_MENU_ITEM', defaultValue)
                
                return defaultValue
            })
        },

        get_show_addon_images({commit}) { 
            fb_remote_config.fetchAndActivate().then(() => {
                const show_addon_images = fb_remote_config.getValue("VUE_APP_CP_SHOW_ADDON_IMAGES").asBoolean()
                commit('SET_SHOW_ADDON_IMAGES', show_addon_images)
                return show_addon_images
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.VUE_APP_CP_SHOW_ADDON_IMAGES

                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_SHOW_ADDON_IMAGES', defaultValue)
                
                return defaultValue
            })
        },

        get_is_klarna_payment_module_allowed({commit}) {
            fb_remote_config.fetchAndActivate().then(()=>{
                const is_klarna_payment_module_allowed = fb_remote_config.getValue("VUE_APP_IS_KLARNA_PAYMENT_MODULE_ALLOWED").asBoolean()
                commit('SET_IS_KLARNA_PAYMENT_MODULE_ALLOWED', is_klarna_payment_module_allowed)
            }) 
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.VUE_APP_IS_KLARNA_PAYMENT_MODULE_ALLOWED

                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_IS_KLARNA_PAYMENT_MODULE_ALLOWED', defaultValue)
                return defaultValue
            })
        },
             
        get_show_carryover({commit}) {
            fb_remote_config.fetchAndActivate().then(() => {
                const show_carryover = fb_remote_config.getValue("VUE_APP_CP_SHOW_CARRYOVER_PARAM").asBoolean()
                commit('SET_SHOW_CARRYOVER', show_carryover)
                return show_carryover
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.VUE_APP_SHOW_CARRYOVER_PARAM
                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_SHOW_CARRYOVER', defaultValue)
                
                return defaultValue
            })
        },
        
        get_is_module_ufb_enabled({commit}) {
            fb_remote_config.fetchAndActivate().then(() => {
                const is_module_ufb_enabled = fb_remote_config.getValue("VUE_APP_CP_MODULE_UFB_ENABLED").asBoolean()
                commit('SET_IS_MODULE_UFB_ENABLED', is_module_ufb_enabled)
                return is_module_ufb_enabled
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.VUE_APP_MODULE_UFB_ENABLED
                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_IS_MODULE_UFB_ENABLED', defaultValue)
            })
        },

        get_show_dashboard_widget({commit}) {
            fb_remote_config.fetchAndActivate().then(() => {
                const show_dashboard_widget = fb_remote_config.getValue("VUE_APP_CP_SHOW_DASHBOARD_WIDGET").asString()
                commit('SET_SHOW_DB_WIDGET', show_dashboard_widget)
                return show_dashboard_widget
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.VUE_APP_CP_SHOW_DASHBOARD_WIDGET
                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_SHOW_DB_WIDGET', defaultValue)
                
                return defaultValue
            })
        },
        
        get_show_hotspot({commit}) {
            fb_remote_config.fetchAndActivate().then(() => {
                const show_hotspot = fb_remote_config.getValue("VUE_APP_SHOW_HOTSPOT_PARAM").asBoolean()
                commit('SET_SHOW_HOTSPOT', show_hotspot)
                return show_hotspot
            })
            .catch((error) => {
                const defaultValue = fb_remote_config.defaultConfig.VUE_APP_SHOW_HOTSPOT_PARAM
                console.warn('Firebase Remote Config failed, using default value:', error)
                commit('SET_SHOW_HOTSPOT', defaultValue)
                
                return defaultValue
            })
        },
    },
    

    mutations: {
        SET_IS_HIDE_PREPAY_TOPUP(state, is_hide_prepay_topup) {
            state.is_hide_prepay_topup = is_hide_prepay_topup
        },

        SET_IS_HIDE_PREPAY_BALANCE_IF_ZERO(state, is_hide_prepay_balance_if_zero) {
            state.is_hide_prepay_balance_if_zero = is_hide_prepay_balance_if_zero
        },

        SET_IS_AFTERPAY_PAYMENT_MODULE_ALLOWED(state, is_afterpay_payment_module_allowed) {
            state.is_afterpay_payment_module_allowed_fb = is_afterpay_payment_module_allowed
        },

        SET_IS_ENABLE_PROMO_CODE_MENU_ITEM(state, is_enable_promo_code_menu_item) {
            state.is_enable_promo_code_menu_item = is_enable_promo_code_menu_item 
        },

        SET_IS_KLARNA_PAYMENT_MODULE_ALLOWED(state, is_klarna_payment_module_allowed) {
            state.is_klarna_payment_module_allowed = is_klarna_payment_module_allowed
        },
        SET_SHOW_ADDON_IMAGES(state, show_addon_images) {
            state.show_addon_images = show_addon_images
        },
        
        SET_SHOW_CARRYOVER(state, show_carryover) {
            state.show_carryover = show_carryover
        },
        
        SET_IS_MODULE_UFB_ENABLED(state, is_module_ufb_enabled) {
            state.is_module_ufb_enabled = is_module_ufb_enabled
        },

        SET_SHOW_DB_WIDGET(state, show_dashboard_widget) {
            state.show_dashboard_widget = show_dashboard_widget
        },

        SET_SHOW_HOTSPOT(state, show_hotspot) {
            state.show_hotspot = show_hotspot
        }
    },
};
